module.exports = __webpack_public_path__ + "static/media/victory.4d925ae0.mp3";